export default __webpack_public_path__ + "f11b87551a96f090346de510f5acda1c.svg";